import JwtService from "../../../core/services/JwtService";
import StorageService from "../../../core/services/StorageService";

export default {
    SET_AUTH(state, {user, token}) {
        state.isAuthenticated = true;
        state.user = user;
        StorageService.saveStorageService("USER_DATA", user);
        if (token) JwtService.saveToken(token);
    },
    PURGE_AUTH(state) {
        state.isAuthenticated = false;
        state.user = {};
        JwtService.destroyToken();
        StorageService.destroyStorageService("LOGIN_PAYLOAD");
        StorageService.destroyStorageService("USER_DATA");
    }
};
